import { unitId } from '@/annotations'
import { Note } from '@/components/Note'
import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'

/**
 * `v-soon` — process/09-SCREEN-SPECS/v-soon.md. **`NO_OPERATION`** — the deliberately unmapped
 * placeholder, so an unbuilt destination renders something honest instead of a broken route
 * (`requirements/95-TRACEABILITY.md` §95.3). It never claims a date (rule 1).
 *
 * **The spec's own Components table names a `button` and an `icon`, both directly "in view" (W156)**
 * — a "Go back" control is the one thing a dead-end placeholder can offer with no operation of its
 * own, `history.back()` matching the identical pattern already established for wizard cancel
 * controls.
 */
export function VSoon() {
  return (
    <div data-scr={unitId('v-soon')}>
      <h1 className="m-0 mb-4 text-section font-semibold">Coming soon</h1>
      <Note>This isn't built yet. There is no date to give you.</Note>
      <div className="mt-6">
        <Button data-act={undefined} ghost onClick={() => history.back()}>
          <Icon name="i-chevL" size="s" />
          Go back
        </Button>
      </div>
    </div>
  )
}
